<p class="advice-message" [innerHTML]="'ai.general.legal.settings.info' | translate"></p>
<p [innerHTML]="'ai.general.legal' | translate"></p>
<stages-custom-ai-policy></stages-custom-ai-policy>
<stages-buttons-bottom [removeBoundaries]="true">
	<stages-button
		[title]="'decline'"
		[buttonClasses]="declineButtonClasses()"
		(clicked)="setAcknowledgementsState('DECLINED')"
	/>
	<stages-button
		[title]="'accept'"
		[buttonClasses]="acceptButtonClasses()"
		(clicked)="setAcknowledgementsState('ACCEPTED')"
	/>
</stages-buttons-bottom>
